import type { UIMatch } from 'react-router';

import { cmsRouteId } from '#/modules/cms/pages/splat/CmsSplat.horizon-route';
import type { CmsSplatPageLoaderData } from '#/modules/cms/pages/splat/CmsSplatPageLoaderData';

export function isSearchLandingPageSSRMatch(
  match: UIMatch,
): match is UIMatch<
  Extract<CmsSplatPageLoaderData, { type: 'SEARCH_LANDING_PAGE' }>
> {
  if (match.id !== cmsRouteId) return false;

  const data = match.data as CmsSplatPageLoaderData;
  if (!data) return false;

  return data.type === 'SEARCH_LANDING_PAGE' && Boolean(data.ssr);
}
